import { PasswordValidator } from 'stageclip-common';
// @ts-ignore
import urlParser from 'js-video-url-parser';

export const required = (value: any) => (value || typeof value === 'number' ? undefined : 'Required');

export const email = (value: any) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Invalid email address' : undefined;

export const maxLength = (max: number) => (value: any) =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const minLength = (min: number) => (value: any) =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined;

export const maxValue = (max: number) => (value: any) =>
  value && Number(value) > max ? `Must be ${max} or less` : undefined;

export const minValue = (min: number) => (value: any) =>
  value && Number(value) < min ? `Must be ${min} or greater` : undefined;

export const integer = (value: any) =>
  value && Math.floor(value) !== Number(value) ? `Must be an integer` : undefined;

export const numberFormat = (value: any) => (value && Number.isNaN(Number(value)) ? 'Must be a number' : undefined);

function isJson(value: any) {
  try {
    JSON.parse(value);
  } catch (e) {
    return false;
  }

  return true;
}

export const jsonFormat = (value: any) => (!value || (value && isJson(value)) ? undefined : 'Must be a valid JSON');

export const alphaNumeric = (value: any) =>
  value && /[^a-zA-Z0-9 ]/i.test(value) ? 'Only alphanumeric characters' : undefined;

export const passwordValidator = (value: any) =>
  value && !PasswordValidator.isValidPassword(value) ? PasswordValidator.PASSWORD_REQUIREMENTS_MESSAGE : undefined;

export const hostnameOnlyValidator = (value: string) =>
  value && value.includes('/')
    ? 'Invalid value. Please include only the hostname (no http:// or relative path)'
    : undefined;

export const azureEndpointValidator = (value: string) =>
  value && !value.includes('.azureedge.net')
    ? "This is not a valid Azure CDN endpoint. It should be of the form 'something.azureedge.net'"
    : undefined;

const URL_REGEX = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;

export const urlValidator = (website: string) => {
  return !website || URL_REGEX.test(website)
    ? undefined
    : 'This is not valid URL. It should start with http:// or https://';
};

const DOMAIN_PREFIX_REGEX = '^[a-z0-9]+(\\-[a-z0-9]+)*$';

export const domainPrefixValidator = (domain: string) => (prefix: string) => {
  return new RegExp(DOMAIN_PREFIX_REGEX).test(prefix) && prefix !== 'www'
    ? undefined
    : `Domain should be a valid ${domain} subdomain without www prefix.`;
};

export const requiredString = (value: any) => (value && typeof value === 'string' ? undefined : 'Required');

export const youtubePlaylistValidator = (website: string) =>
  !website || (website && urlParser.parse(website)?.provider === 'youtube' && (urlParser.parse(website) as any)?.list)
    ? undefined
    : 'This is not a valid YouTube playlist';
